<form *ngIf="form" [formGroup]="form" (submit)="save()" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div *ngIf="isLoadingExport" style="position: fixed; top: 0; left: 0; width: 100%; background-color: #4CAF50; color: white; padding: 10px; text-align: center; z-index: 10000;">
    Produzione file in corso...
  </div>
  <div *ngIf="isLoadingExport" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(200, 200, 200, 0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title">{{ fields.title | translate }}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button *ngIf="backButton" pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left"
          (click)="backBtn()" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left"
          label="{{'common.save' | translate}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">
        <div class="ui-g-10 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationCluster.description.nullable}">{{
            validationCluster.description.keyName }}

          </span>
          <input type="text" pInputText class="fieldInput" formControlName="description" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
            [validation]="validationCluster.description"></app-validation-msg>

        </div>

        <div class="ui-g-10 ui-md-4">
          <span class="label" [ngClass]="{'required': !validationCluster.cluster_type_id.nullable}">{{
            validationCluster.cluster_type_id.keyName }}</span>
          <p-dropdown [options]="listClusterType" formControlName="cluster_type_id"
            [style]="{ width: '100%' }"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
            [validation]="validationCluster.cluster_type_id"></app-validation-msg>
        </div>

        <div class="ui-g-10 ui-md-4">
          <span class="label" [ngClass]="{'required': true}">{{ validationCluster.code.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="code"
            pTooltip="{{'common.noSpecialChar' | translate}}" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
            [arrayValidators]="[validators.noSpecialCharacters]"
            [validation]="validationCluster.code"></app-validation-msg>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-11 ui-md-11 ui-lg-11">
          <h3 class="title">{{ fields.validityTime | translate }}</h3>
        </div>
        <div class="ui-g-12 ui-md-12 ">
          <button pButton (click)="aggiungi()" icon="fa fa-plus-circle" iconPos="right" type="button"
            class="k-generic-btn" label="{{'common.add' | translate}}" [disabled]="!clusterId"></button>
        </div>
      </div>

      <div class="ui-g-12">
        <app-campaign-3-kontable [source]="tableDataObjects" [service]="null" [columns]="[
            {field: 'clusterHeadId', title:'common.id', filterType: numberFilter, sortable: true },
            { field: 'clusterDescription', title: 'cluster.description', filterType: textFilter, sortable: true },
            { field: 'date_start', title: 'cluster_head.date_start', filterType: dateFilter, sortable: true, bodyTemplate: dateStartTemplate},
            { field: 'date_end', title: 'cluster_head.date_end', filterType: dateFilter, sortable: true, bodyTemplate: dateEndTemplate },
            { field: 'status', title: 'cluster_head.status', filterType: selectFilter, sortable: false, bodyTemplate: statusCellTemplate, filterOptions: {values: statusOptions}},
            { field: 'totalCustomers', title: 'cluster_head.total_clients', filterType: noFilter, sortable: true},
            { field: 'totalActiveCustomers', title: 'cluster_head.active_clients', filterType: noFilter, sortable: true }
          ]" [paginationType]="clientPagination" [showEditButton]="false" [showDeleteButton]="false"
          [showDetailsButton]="false" [showInfoButton]="false" [showRecoverButton]="false" [showGlobalFilter]="false"
          [showResetFiltersBtn]="true" [columnFiltersEnabled]="true" [showRowButtons]="true"
          [additionalRowCommands]="rowCommandsTemplate"
          [(fireNewDataAvailable)]="fireNewDataAvailable"></app-campaign-3-kontable>
      </div>


        <ng-template #dateStartTemplate let-row>
          <span *ngIf="row.date_start">
            {{ row.date_start | date: 'dd/MM/yyyy' }}
          </span>
        </ng-template>

        <ng-template #dateEndTemplate let-row>
          <span *ngIf="row.date_end">
            {{ row.date_end | date: 'dd/MM/yyyy' }}
          </span>
        </ng-template>

        <ng-template #statusCellTemplate let-row>
          <div class="status-badge-table" *ngIf="row.status" [ngClass]="'badge-' + row.status.toLowerCase()">
            <span class="status-dot" [ngClass]="'dot-' + row.status.toLowerCase()"></span>
            {{ 'status.' + row.status.toLowerCase() | translate }}
          </div>
        </ng-template>

        <ng-template #rowCommandsTemplate let-row>
          <button *ngIf="row.status !== 'expired'" pButton type="button" icon="fa fa-pencil-square-o"
            class="ui-button-info" style="margin-right: 5px;" [pTooltip]="'cluster_head.edit_cluster_head' | translate"
            tooltipPosition="top" (click)="editPeriodModal(row)"></button>

          <button pButton type="button" icon="fa fa-external-link" class="ui-button-warning" style="margin-right: 5px;"
            [pTooltip]="'cluster_head.manage_touchpoints' | translate" tooltipPosition="top"
            (click)="getOChannelFromHead(row)"></button>

          <button pButton type="button" icon="fa fa-users" class="ui-button-secondary" style="margin-right: 5px;"
            [pTooltip]="'cluster_head.export_all_clients' | translate" tooltipPosition="top"
            (click)="exportAllCustomers(row.clusterHeadId)"></button>

          <button *ngIf="row.status === 'active'" pButton type="button" icon="fa fa-download" class="ui-button-success"
            style="margin-right: 5px;" [pTooltip]="'cluster_head.export_valid_clients' | translate"
            tooltipPosition="top" (click)="exportValidCustomerDebug(row)"></button>

          <button *ngIf="row.status === 'active'" pButton type="button" icon="fa fa-eraser" class="ui-button-danger"
            style="margin-right: 5px;" [pTooltip]="'cluster_head.empty_valid_clients' | translate" tooltipPosition="top"
            (click)="emptyValidCustomers(row)"></button>

          <button
            *ngIf="row.status === 'future' || (!row.clusterHeadId && row.status !== 'active' && row.status !== 'expired')"
            pButton type="button" icon="fa fa-trash" style="background-color: #3b5998;"
            [pTooltip]="'common.delete' | translate" tooltipPosition="top" (click)="deleteHead(row)"></button>
        </ng-template>
      </div>
    </div>

  <p-dialog header="{{fields.touch_point | translate}}" [style]="{'overflow': 'scroll','max-height': '600px'}"
    [(visible)]="showModaleOChannel" [modal]="true" [draggable]="true" [resizable]="false" [minHeight]="600"
    [width]="700">
    <div class="ui-g-12 ui-md-12 ">
      <button pButton (click)="aggiungiOChannel()" icon="fa fa-plus-circle" iconPos="right" type="button"
        class="k-generic-btn" label="{{'common.add' | translate}}"></button>
    </div>

    <div formArrayName="ochannels" class="formClusterOchannel">
      <div class="ui-g-12 ui-fluid" *ngFor="let ochannel of ochannels.controls; let i=index" [formGroupName]="i">

        <p-panel class="ui-g-12">
          <p-header>
            <div class="ui-helper-clearfix">
              <span class="ui-panel-title" style="line-height: 25px;">#{{ i + 1 }}</span>
              <button pButton type="button" (click)="deleteOChannel(i, ochannel)" icon="fa fa-times" iconPos="center"
                class="ui-button-danger btnDelete" style="width: 27px; float: right;"></button>
            </div>
          </p-header>

          <div class="clearfix">

            <div class="ui-g-12 ui-md-12">
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !validationClusterHeadOChannel.ochannel_id.nullable}">{{
                  validationClusterHeadOChannel.ochannel_id.keyName }}</span>
                <p-dropdown [options]="listPromotionOchannel" formControlName="ochannel_id"
                  [style]="{ width: '100%' }"></p-dropdown>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel"
                  [validation]="validationClusterHeadOChannel.ochannel_id"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-4" *ngIf="checkOchannel(ochannel.value)">
                <span class="label">{{ validationClusterHeadOChannel.flg_direct_active.keyName }}</span>
                <p-dropdown formControlName="flg_direct_active" [options]="directActiveValues"
                  [style]="{ width: '100%' }"></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12 ui-md-12">
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !validationClusterHeadOChannel.description.nullable}">{{
                  validationClusterHeadOChannel.description.keyName }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="description" />
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel"
                  [validation]="validationClusterHeadOChannel.description"></app-validation-msg>
              </div>

              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !validationClusterHeadOChannel.conversion_code.nullable}">{{
                  validationClusterHeadOChannel.conversion_code.keyName }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="conversion_code" />
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel"
                  [arrayValidators]="[validators.noSpecialCharacters]"
                  [validation]="validationClusterHeadOChannel.conversion_code"></app-validation-msg>
              </div>
            </div>
            <div class="ui-g-12 ui-md-12">
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !validationClusterHeadOChannel.icon_b64.nullable}">{{
                  validationClusterHeadOChannel.icon_b64.keyName }}</span>
                <div class="iconContainer">

                </div>
                <p-fileUpload name="icon_b64_upload[]" customUpload="true" [multiple]="false" auto="true"
                  (uploadHandler)="onIconUpload($event,i)" accept="image/*" maxFileSize="1000000" fileLimit="1"
                  chooseLabel="{{ 'cluster_ochannel.upload' | translate }}">
                  <ng-template let-file pTemplate="file">
                  </ng-template>
                  <ng-template pTemplate="content">
                  </ng-template>

                </p-fileUpload>
                <div class="iconContainer" *ngIf="ochannel.controls['icon_b64'].value!=null">
                  <br />
                  <img src="{{ochannel.controls['icon_b64'].value}}" alt="" />
                  <i class="fa fa-close" (click)="onClickRemoveB64(i)" style="cursor:pointer;"></i>
                </div>

                <div *ngIf="ochannel.controls['icon_b64'].value==null">
                  {{ 'cluster_ochannel.no_img' | translate }}
                </div>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel"
                  [validation]="validationClusterHeadOChannel.icon_b64"></app-validation-msg>


              </div>
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !validationClusterHeadOChannel.icon_url.nullable}">{{
                  validationClusterHeadOChannel.icon_url.keyName }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="icon_url"
                  (input)="onKeyPress($event,i)" />
                <br />
                <a href=""></a>
                <div class="iconContainer" *ngIf="ochannel.controls['icon_url'].value">
                  <br />
                  <img [src]="ochannel.controls['icon_url'].value" alt="" />
                  <i class="fa fa-close" (click)="onClickRemoveUrl(i)" style="cursor:pointer;"></i>
                </div>
                <div class="" *ngIf="!ochannel.controls['icon_url'].value">{{ 'cluster_ochannel.no_img' | translate }}
                </div>

                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel"
                  [validation]="validationClusterHeadOChannel.icon_url"></app-validation-msg>
              </div>
            </div>

          </div>
          <p-footer>
            <div class="clearfix">
              <button pButton (click)="addOChannel()" type="button" class="roundedButton slim" label="Salva"
                [disabled]="!form.valid"></button>
            </div>
          </p-footer>
        </p-panel>
        <div class="clearfix"></div>

      </div>
    </div>
  </p-dialog>
</form>

<p-dialog
  header="{{ (currentPeriodIndex === -1 ? 'cluster_head.add_cluster_head' : 'cluster_head.edit_cluster_head') | translate }}"
  [(visible)]="showPeriodModal" [modal]="true" [width]="800" [responsive]="true" [closable]="false">

  <ng-container *ngIf="currentPeriodForm && validationClusterHead">
    <form [formGroup]="currentPeriodForm">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12">
          <span class="label" [ngClass]="{'required': !validationClusterHead?.description?.nullable}">
            {{'cluster_head.description' | translate}}
          </span>
          <input type="text" pInputText class="fieldInput" formControlName="description" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="currentPeriodForm"
            [validation]="validationClusterHead?.description"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-6"
          [ngStyle]="{'pointer-events': currentPeriodForm?.get('date_start')?.disabled ? 'none' : 'auto', 'opacity': currentPeriodForm?.get('date_start')?.disabled ? '0.6' : '1'}">
          <span class="label" [ngClass]="{'required': !validationClusterHead?.date_start?.nullable}">
            {{ 'cluster_head.date_start' | translate }}
          </span>
          <app-kv-calendar #modalDateStartField [inputName]="'date_start'" [formData]="currentPeriodForm"
            [minDate]="dateStartMin" [maxDate]="dateStartMax" [startDateSelector]="true" [endDateInputName]="'date_end'"
            [endDateCalendar]="modalDateEndField" [defaultDate]="modalDefaultStartDate"
            [defaultValue]="currentPeriodIndex === -1 ? null : modalDefaultStartDate">
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="currentPeriodForm"
            [validation]="validationClusterHead?.date_start"></app-validation-msg>
          <span *ngIf="dateStartIssue" style="color: #e62a10; font-size: 12px; display: block; margin-top: 5px;">
            {{'cluster_head.validation_message' | translate}}
          </span>
        </div>

        <div class="ui-g-12 ui-md-6"
          [ngStyle]="{'pointer-events': currentPeriodForm?.get('date_end')?.disabled ? 'none' : 'auto', 'opacity': currentPeriodForm?.get('date_end')?.disabled ? '0.6' : '1'}">
          <span class="label" [ngClass]="{'required': !validationClusterHead?.date_end?.nullable}">
            {{ 'cluster_head.date_end' | translate }}
          </span>
          <app-kv-calendar #modalDateEndField [inputName]="'date_end'" [formData]="currentPeriodForm"
            [endDateSelector]="true" [startDateInputName]="'date_start'" [startDateCalendar]="modalDateStartField"
            [minDate]="dateEndMin" [defaultDate]="modalDefaultEndDate"
            [defaultValue]="currentPeriodIndex === -1 ? null : modalDefaultEndDate">
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="currentPeriodForm"
            [validation]="validationClusterHead?.date_end"></app-validation-msg>
        </div>

        <div class="ui-g-12" *ngIf="modalPeriodStatus === 'Active'"
          style="margin-top: 15px; border-top: 1px solid #ddd; padding-top: 15px;">

          <div class="ui-g">
            <div class="ui-g-12 ui-md-12"
              [ngStyle]="{'pointer-events': currentPeriodForm?.get('update_customers_dates')?.disabled ? 'none' : 'auto', 'opacity': currentPeriodForm?.get('update_customers_dates')?.disabled ? '0.6' : '1'}">
              <p-checkbox binary="true" formControlName="update_customers_dates"
                label="{{'cluster_head.checkbox_message' | translate}}" (onChange)="resetRadioChoice()">
              </p-checkbox>
            </div>
          </div>

          <div class="ui-g" *ngIf="currentPeriodForm.get('update_customers_dates').value"
            style="margin-top: 15px; padding-left: 30px;">

            <div class="ui-g-12 ui-md-6">
              <p-radioButton name="updateType" value="ONLY_ACTIVE" label="{{'cluster_head.only_active' | translate}}"
                formControlName="update_customers_type" styleClass="radio-fix"></p-radioButton>
            </div>

            <div class="ui-g-12 ui-md-6">
              <p-radioButton name="updateType" value="CUSTOM_DATE" label="{{'cluster_head.custom_date' | translate}}"
                formControlName="update_customers_type" styleClass="radio-fix"></p-radioButton>

              <div style="margin-top: 10px; min-height: 45px;">
                <app-kv-calendar *ngIf="currentPeriodForm.get('update_customers_type').value === 'CUSTOM_DATE'"
                  #modalCustomDateField [inputName]="'update_customers_custom_date'" [formData]="currentPeriodForm"
                  [defaultDate]="modalCustomEndDate" [defaultValue]="modalCustomEndDate">
                </app-kv-calendar>
              </div>
            </div>

            <div class="ui-g-4" *ngIf="currentPeriodForm.get('update_customers_type').value" style="margin-top: 10px;">
              <button pButton type="button" icon="fa fa-calculator" label="{{'cluster_head.calc_button' | translate}}"
                class="ui-button-info" (click)="countCustomersToUpdate()"></button>

              <div *ngIf="calculatedCustomersCount !== null"
                style="display: inline-block; margin-left: 15px; margin-top: 5px ;padding: 5px 10px;">
                <strong>{{'cluster_head.customers_found' | translate}}</strong> {{ calculatedCustomersCount }}
              </div>
            </div>

          </div>
        </div>
        <div class="ui-g-12" *ngIf="modalPeriodStatus === 'Future'"
          style="margin-top: 15px; border-top: 1px solid #ddd; padding-top: 15px;">
          <div class="ui-g">
            <div class="ui-g-12 ui-md-12"
              [ngStyle]="{'pointer-events': currentPeriodForm?.get('update_customers_dates')?.disabled ? 'none' : 'auto', 'opacity': currentPeriodForm?.get('update_customers_dates')?.disabled ? '0.6' : '1'}">
              <p-checkbox binary="true" formControlName="update_customers_dates"
                label="{{'cluster_head.checkbox_message' | translate}}" (onChange)="resetRadioChoice()">
              </p-checkbox>
            </div>
          </div>
          <div class="ui-g" *ngIf="currentPeriodForm.get('update_customers_dates').value"
            style="margin-top: 15px; padding-left: 30px;">

            <div class="ui-g-12 ui-md-6">
              <p-radioButton name="updateType" value="ONLY_ACTIVE" label="{{'cluster_head.only_active' | translate}}"
                formControlName="update_customers_type" styleClass="radio-fix"></p-radioButton>
            </div>

            <div class="ui-g-12 ui-md-6">
              <p-radioButton name="updateType" value="CUSTOM_DATE" label="{{'cluster_head.custom_date' | translate}}"
                formControlName="update_customers_type" styleClass="radio-fix"></p-radioButton>

              <div style="margin-top: 10px; min-height: 45px;">
                <app-kv-calendar *ngIf="currentPeriodForm.get('update_customers_type').value === 'CUSTOM_DATE'"
                  #modalCustomDateField [inputName]="'update_customers_custom_date'" [formData]="currentPeriodForm"
                  [defaultDate]="modalCustomEndDate" [defaultValue]="modalCustomEndDate">
                </app-kv-calendar>
              </div>
            </div>

            <div class="ui-g-4" *ngIf="currentPeriodForm.get('update_customers_type').value" style="margin-top: 10px;">
              <button pButton type="button" icon="fa fa-calculator" label="{{'cluster_head.calc_button' | translate}}"
                class="ui-button-info" (click)="countCustomersToUpdate()"></button>

              <div *ngIf="calculatedCustomersCount !== null"
                style="display: inline-block; margin-left: 15px; margin-top: 5px ;padding: 5px 10px;">
                <strong>{{'cluster_head.customers_found' | translate}}</strong> {{ calculatedCustomersCount }}
              </div>
            </div>

          </div>

        </div>
      </div>

    </form>
  </ng-container>

  <p-footer>
    <button pButton type="button" icon="fa fa-times" label="{{'common.cancel' |translate}}" class="ui-button-secondary"
      (click)="annullaPeriodModal()"></button>
    <button pButton type="button" label="{{'common.save' |translate}}" class="ui-button-success"
      (click)="savePeriodModal()"
      [icon]="(!currentPeriodForm?.valid || (currentPeriodIndex !== -1 && currentPeriodForm?.pristine)) ? 'fa fa-lock' : 'fa fa-check'"
      [disabled]="!currentPeriodForm?.valid || (currentPeriodIndex !== -1 && currentPeriodForm?.pristine)"></button>
  </p-footer>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster/form-cluster-loyalty/form-cluster-loyalty.component.html